/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
function _createMdxContent(props) {
  const _components = Object.assign({
    h1: "h1",
    ul: "ul",
    li: "li",
    a: "a",
    h3: "h3",
    pre: "pre",
    code: "code",
    h2: "h2",
    p: "p",
    strong: "strong",
    em: "em"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h1, {
      children: "v7.2"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "#new-colors",
          children: "New colors"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "#new-components",
          children: "New components"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "#new-elements",
          children: "New elements"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "#new-helper-functions",
          children: "New helper functions"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "#install",
          children: "How to Install"
        })
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      children: "New colors"
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-css",
        children: "/* New */\ncolor: var(--color-black-55);\ncolor: var(--color-black-20);\ncolor: var(--color-black-8);\ncolor: var(--color-black-3);\n"
      })
    }), "\n", _jsx(_components.h2, {
      children: "New components"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "/uilib/components/skeleton",
          children: "Skeleton"
        }), " to show the DNB skeleton preset. Skeletons are also built into every component and element."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "/uilib/components/dropdown#dropdown-action_menu",
          children: "ActionMenu"
        }), " – this menu is extended from the Dropdown."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "/uilib/components/dropdown/demos#dropdown-item-content-directions",
          children: "Dropdown.HorizontalItem"
        }), " – to more easily place items content in a horizontal direction (same applies to ", _jsx(_components.code, {
          children: "Autocomplete.HorizontalItem"
        }), ")."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "/uilib/patterns/payment-card",
          children: "PaymentCard"
        }), " – a component to imitate a physical payment card."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "/uilib/components/help-button",
          children: "HelpButton"
        }), " – a help button with a custom semantic, helping screen readers determine the meaning of that button."]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["With the new ", _jsx(_components.a, {
        href: "/uilib/components/help-button",
        children: "HelpButton"
      }), ", you can simply use it like you used to with the Modal."]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        children: "<Input\n    label=\"Input\"\n    placeholder=\"Placeholder ...\"\n    suffix={<HelpButton>Help text</HelpButton>}\n/>\n"
      })
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.strong, {
        children: "NB:"
      }), " Use the new ", _jsx(_components.code, {
        children: "trigger_attributes"
      }), " to send along HTML attributes, if you still use the ", _jsx(_components.a, {
        href: "/uilib/components/modal",
        children: "Modal/Drawer"
      }), " ", _jsx(_components.code, {
        children: "<Modal trigger_attributes={{ 'aria-label': }} ..."
      }), "."]
    }), "\n", _jsx(_components.h3, {
      children: "Updates to the language files"
    }), "\n", _jsxs(_components.p, {
      children: ["The new default locale for English is: ", _jsx(_components.code, {
        children: "en-GB"
      }), " – but will be backward compatible to ", _jsx(_components.code, {
        children: "en-US"
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["Strings were changed/removed and added to the ", _jsx(_components.a, {
        href: "/uilib/usage/customisation/localization",
        children: "language files"
      }), " ", _jsx(_components.code, {
        children: "nb-NO.js"
      }), " and ", _jsx(_components.code, {
        children: "en-GB.js"
      }), ":"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "Skeleton (added)"
      }), "\n", _jsx(_components.li, {
        children: "HelpButton (added)"
      }), "\n", _jsx(_components.li, {
        children: "Slider (added)"
      }), "\n", _jsx(_components.li, {
        children: "Input (added)"
      }), "\n", _jsxs(_components.li, {
        children: ["GlobalStatus (updated string ", _jsx(_components.code, {
          children: "Gå til %s"
        }), " / ", _jsx(_components.code, {
          children: "Go to %s"
        }), ")"]
      }), "\n", _jsxs(_components.li, {
        children: ["Modal (removed string ", _jsx(_components.code, {
          children: "more_info"
        }), ")"]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      children: "New elements"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "/uilib/elements/lists",
          children: "list elements as React components"
        }), " – ", _jsx(_components.code, {
          children: "Li"
        }), ", ", _jsx(_components.code, {
          children: "Dt"
        }), " and ", _jsx(_components.code, {
          children: "Dd"
        }), ". ", _jsx(_components.strong, {
          children: "Ol Lists"
        }), " do now also support the ", _jsx(_components.code, {
          children: "type"
        }), " HTML attribute in order to use like ", _jsx(_components.em, {
          children: "letters"
        }), " and ", _jsx(_components.em, {
          children: "roman numerals"
        }), "."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "/uilib/elements",
          children: "Image, span and div"
        }), " elements to support more easily the ", _jsx(_components.a, {
          href: "/uilib/components/skeleton",
          children: "Skeleton"
        }), " provider."]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      children: "New helper functions"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "/uilib/usage/customisation/localization#how-to-use-your-own-translation-strings",
          children: "useTranslation"
        }), " hook to consume your own translation strings."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "/uilib/helpers/functions",
          children: "InteractionInvalidation"
        }), " method – used by the Modal to invalidate everything outside of the modal to be accessible for keyboard and screen readers."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "/uilib/helpers/functions",
          children: "debounce"
        }), " method – used by AutoComplete to delay asynchronous typed searches."]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      children: "Enhancements"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "DNB Medium"
        }), " font got an enhancement regarding readability on Windows."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "/uilib/components/date-picker",
          children: "DatePicker"
        }), " got an internal overhauling, new styles and an ", _jsx(_components.code, {
          children: "on_days_render"
        }), " render prop as well as ", _jsx(_components.code, {
          children: "on_type"
        }), " event because of the new UX. Now it is possible to invalidate a part of a in the input."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "/uilib/components/global-status",
          children: "GlobalStatus"
        }), " got ", _jsx(_components.code, {
          children: "GlobalStatus.create"
        }), " to use instead of ", _jsx(_components.code, {
          children: "GlobalStatus.AddStatus"
        }), " and ", _jsx(_components.code, {
          children: "GlobalStatus.Set"
        }), " alongside with a an overall more stable internal architecture for live updated data and better height animation."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "/uilib/components/form-status",
          children: "FormStatus"
        }), " now updates it's statuses and send it along to ", _jsx(_components.a, {
          href: "/uilib/components/global-status",
          children: "GlobalStatus"
        }), "."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "/uilib/components/modal",
          children: "Modal & Drawer"
        }), " new UX styles and props like ", _jsx(_components.code, {
          children: "spacing"
        }), " and an helper wrapper called ", _jsx(_components.code, {
          children: "Modal.Inner"
        }), "."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "/uilib/components/tabs",
          children: "Tabs"
        }), " do not wrap anymore in mobile view (", _jsx(_components.code, {
          children: "< 40em"
        }), "), but will rather be scrollable with helper buttons for navigation."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "/uilib/components/slider",
          children: "Slider"
        }), " got a new prop ", _jsx(_components.code, {
          children: "number_format"
        }), ". This let's you define the values of the slider to be formatted a given way (", _jsx(_components.code, {
          children: "number_format={{ currency: true, decimals: 0 }}"
        }), ")."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "/uilib/components/input#input-password-type",
          children: "InputPassword"
        }), " got a separate show/hide password component."]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      children: "Install"
    }), "\n", _jsx(_components.p, {
      children: "To upgrade to v7 with NPM, use:"
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-bash",
        children: "$ npm i dnb-ui-lib@7\n"
      })
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.em, {
        children: "November, 8. 2020"
      })
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
